// Constructs a link used by condensed ScoreGames to link to approprirate
// gameday section
const getCondensedGamedayLink = (
    urlRoot,
    gamedayType,
    codedGameState,
    abstractGameCode,
    statusCode,
    gamePk,
    fallbackUrl = ''
) => {
    if (codedGameState !== 'S' &&
      gamedayType !== 'N' ||
      gamedayType !== 'L' ||
      gamedayType !== 'S') {
        if ((abstractGameCode === 'P' && statusCode === 'S') || codedGameState === 'D' || codedGameState === 'C') {
            return getGamedayPreviewUrl(urlRoot, gamePk);
        } else if ((abstractGameCode === 'P' && statusCode !== 'S') || abstractGameCode === 'L') {
            return getGamedayUrl(urlRoot, gamePk);
        } else if (abstractGameCode === 'F') {
            if (codedGameState !== 'C' && codedGameState !== 'D') {
                return getGamedayWrapUrl(urlRoot, gamePk);
            }
        }
    }
    return fallbackUrl;
};

// Preview
export const getGamedayPreviewUrl = (urlRoot, gamePk) => {
    return `${urlRoot}/gameday/${gamePk}/preview`;
};

// Normal Gameday
export const getGamedayUrl = (urlRoot, gamePk) => {
    return `${urlRoot}/gameday/${gamePk}`;
};

// Final Box
export const getGamedayBoxUrl = (urlRoot, gamePk) => {
    return `${urlRoot}/gameday/${gamePk}/final/box`;
};

// Video (AKA highlights)
export const getGamedayVideoUrl = (urlRoot, gamePk) => {
    return `${urlRoot}/gameday/${gamePk}/live/video`;
};

// Final Video (AKA highlights)
export const getGamedayFinalVideoUrl = (urlRoot, gamePk) => {
    return `${urlRoot}/gameday/${gamePk}/final/video`;
};

// Final Wrap
export const getGamedayWrapUrl = (urlRoot, gamePk) => {
    return `${urlRoot}/gameday/${gamePk}/final/wrap`;
};

export default getCondensedGamedayLink;
